import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import * as _ from 'lodash';
import { ProductoService } from '../../../services/producto/producto.service';

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: []
})
export class CategoriaComponent implements OnInit {

  categoriaId: number;
  categoriaHijaId: number;
  categoria: any = {};
  categoriaPadre: any = {};
  categoriaHija: any = {};
  marcas: any[] = [];
  productosTodos: ElementoCarro[] = [];
  productosCategoria: ElementoCarro[] = [];
  productosMostrados: ElementoCarro[] = [];
  ordenProductos = 'destacados';

  categoriaTodos = {
    'id': 0,
    'nombre': 'Todos'
  };

  categoriaSeleccionada: any = this.categoriaTodos;
  statusMarcaFltros: any[] = [];

  checkTodasMarcas = false;

  constructor(
    private _categoriaService: CategoriaService,
    private _carritoService: CarritoService,
    private _productoService: ProductoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( params => {
      // Si solo cambia la categoria hija

      if ((this.categoriaId === Number(params.padreId)) && this.categoriaHijaId !== Number(params.hijaId)) {
        this.categoriaHijaId = Number(params.hijaId);
        this.cambiaSubCategoria();
      } else {

        this.categoriaId = Number(params.padreId);
        this.categoriaHijaId = Number(params.hijaId);

        this.cambiaCategoriaPadre();
      }

    });
  }

  ngOnInit() {

  }

  cambiaCategoriaPadre() {
    this.categoria = {};
    this.marcas = [];
    this.productosTodos = [];
    this.productosCategoria = [];
    this.productosMostrados = [];

    this._categoriaService.get(this.categoriaId)
      .subscribe( data => {
        this.categoria = data;
        this.categoriaPadre = this.categoria;
        this.categoriaHija = _.find(this.categoriaPadre.categoriasHijas, (item: any) => {
          return item.id === this.categoriaHijaId;
        });
    });

    this._categoriaService.getTotalProductos(this.categoriaId)
      .subscribe( data => {
        this.productosTodos = this._carritoService.enriquecerProductos(data);
        this.productosCategoria = this.productosTodos;
        this.productosMostrados = this.productosTodos;

        this.cambiaSubCategoria();

      });

    this._carritoService.carroProductos
      .subscribe( data => {
        this.productosTodos = this._carritoService.actualizarProductos(this.productosTodos);
      });

    this._categoriaService.getTotalMarcas(this.categoriaId)
      .subscribe( data => {
        this.marcas = data;
      });
  }


  cambiaSubCategoria() {

    this.productosCategoria = [];
    this.productosMostrados = [];

    if (this.categoriaHijaId !== 0) {
      const hijaSel = _.find(this.categoria.categoriasHijas, cat => {
        if (cat.id === this.categoriaHijaId) {
          return cat;
        }
      });

      this.categoriaHija = _.find(this.categoriaPadre.categoriasHijas, (item: any) => {
        return item.id === this.categoriaHijaId;
      });

      if (hijaSel) {
        this.filtrarProductos(hijaSel);
      }
    } else {
      this.categoriaHija = {id: 0, nombre: 'Todos'};
      this.filtrarProductos(this.categoriaTodos);
    }

  }


  filtrarProductos(categoria: any) {
    this.categoriaSeleccionada = categoria;

    if (categoria.id === 0) {
      this.productosCategoria = this.productosTodos;
      this.productosMostrados = this.productosTodos;
    } else {
      const listaProd: ElementoCarro[] = [];

      _.forEach(categoria.porductos, (pivot) => {

        const aux = _.find(this.productosTodos, itemCarro =>  {
          if (itemCarro.producto.id === pivot.productoId) {
            return itemCarro;
          }
        });

        if (aux) {
          listaProd.push(aux);
        }

      });

      this.productosMostrados = listaProd;
      this.productosCategoria = listaProd;
      this.ordenarProductos();
    }

    this.filtrarPorMarca();
  }

  filtrarPorMarca() {

    this.statusMarcaFltros = _.filter(this.marcas, {'isSelected': true});

    if (this.statusMarcaFltros.length > 0) {

      this.checkTodasMarcas = false;

      let listaProd: ElementoCarro[] = [];

      _.forEach(this.statusMarcaFltros, (marca) => {

        const encontrados = _.filter(this.productosCategoria, itemCarro => {
          if (itemCarro.producto.marcaId === marca.id) {
            return itemCarro;
          }
        });

        if (encontrados) {
          listaProd = listaProd.concat(encontrados);
        }

      });

      this.productosMostrados = listaProd;
    } else {
      this.productosMostrados = this.productosCategoria;
    }

    this.ordenarProductos();
  }

  ordenarProductos(model?: string) {

    if (model) {
      this.ordenProductos = model;
    }

    switch (this.ordenProductos) {
      case 'destacados': {
        this.productosMostrados = _.orderBy(this.productosMostrados, (o: ElementoCarro) => {
          return o.producto.seleccionSF;
        });
        break;
      }
      case 'masNuevos': {
        this.productosMostrados = _.orderBy(this.productosMostrados, (o: ElementoCarro) => {
          return o.producto.fecCreacion;
        }, 'desc');
        break;
      }
      case 'alfabeticamente': {
        this.productosMostrados = _.orderBy(this.productosMostrados, (o: ElementoCarro) => {
          return o.producto.nombre;
        });
        break;
      }
    }

  }

  limpiarFiltroMarca() {

      this.statusMarcaFltros = [];

      _.forEach(this.marcas, (marca) => {
        marca.isSelected = false;
      });

      this.productosMostrados = this.productosCategoria;
      this.ordenarProductos();
  }


  agregarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

  linkAlProducto(route: any) {
    this._productoService.setProductoCategoriaActive(this.categoria.categoriaId);
    this.router.navigate(route);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/categoria/categoria.component.ts